<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: Datalabs.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,   -->
<!-- propagated, or distributed without prior approval by ESA.               -->
<template>
  <div class="datalabs container">
    <!-- <h4 v-if="labs.length">My Labs</h4> -->

    <!-- --------------------------------- -->
    <!--          RUNNING LABS             -->
    <!-- --------------------------------- -->
    <h2 v-if="auth && isUser" class="datalabs__running-title">
      <i class="icon icon-lab text-primary bold-me"></i>Continue Working
    </h2>
    <div v-if="auth && isUser" class="datalabs__running section row">
      <div
        v-if="warningMessage != ''"
        class="col-cards col-sm-6 col-lg-3 col-xl-3 col-xxl-2 d-flex justify-content-center"
      >
        <div v-if="warningMessage != ''" id="warning-message" class="alert alert-primary card" role="alert">
          {{ warningMessage }}
        </div>
      </div>
      <div
        v-for="(lab, idx) in labs"
        :key="idx"
        class="col-cards col-sm-6 col-lg-3 col-xl-3 col-xxl-2 d-flex justify-content-center"
      >
        <div class="datalabs__item card theme-shadow" :class="clsMostRecent(idx)">
          <div class="card-figure">
            <!-- <img
              class="card-img-top"
              @click="openLab(lab)"
              :src="wpData.image_path + labLogo(lab.image)"
              alt="Card image cap"
            /> -->
            <img class="card-img-top" @click="openLab(lab)" :src="lab.picture" alt="Card image cap" />
          </div>
          <div class="card-body">
            <div class="card-body-content d-flex flex-row justify-content-between">
              <div class="card-body-text">
                <p class="card-title">
                  <a v-if="lab.status === 'Running'" class="name" @click="openLab(lab)">{{ lab.name }}</a>
                  <span v-else>{{ lab.name }}</span>
                </p>
                <!-- <p class="card-description">{{ lab.description }}</p> -->
                <!-- <p class="card-text">
                  <em>{{ lab.image }}</em>
                </p>-->
                <p v-if="lab.status === 'Initializing'" class="card-text">
                  {{ lab.status }}
                </p>
                <p v-if="lab.status !== 'Initializing'" class="card-last-access">Last access: {{ lab.lastAccess }}</p>
              </div>
              <div class="card-icons">
                <i v-if="lab.status === 'Paused'" title="Paused" class="font-18 icon-sleep-line"></i
                ><i v-else-if="lab.status === 'Running'" title="Running" class="font-18 icon-running"></i>
                <i v-else-if="lab.status === 'Initializing'" title="Initializing" class="font-18 icon-progress"></i>
              </div>
            </div>
            <div class="card-right d-flex flex-column align-items-end justify-content-start">
              <div class="card-buttons">
                <!-- Stop Button -->
                <!-- Start Button -->
                <!-- <button
                  v-else
                  class="datalabs__start card-body-button btn btn-reset"
                  @click.prevent="startLab(lab)"
                  >
                  <i class="icon icon-play"></i>
                </button>-->

                <!-- Open Filter button -->
                <!-- <button
                  class="datalabs__filter card-body-button btn btn-reset"
                  @click.prevent="$router.push(lab.filterLink)"
                  >
                  <i class="icon icon-filter2"></i>
                </button>-->
                <!-- Edit Button -->
                <!-- <button
                  class="datalabs__edit card-body-button btn btn-reset"
                  @click.prevent="openEditLabModal(lab)"
                  >
                  <i class="icon icon-edit"></i>
                </button>-->
                <!-- Open lab button -->
                <button
                  v-if="lab.status !== 'Initializing'"
                  @click.prevent="openLab(lab)"
                  class="datalabs__open card-body-button btn btn-reset"
                  title="Open"
                >
                  <i class="icon icon-play"></i>
                </button>
                <button
                  v-if="lab.status === 'Running'"
                  class="datalabs__stop card-body-button btn btn-reset"
                  @click.prevent="stopLab(lab)"
                >
                  <i class="icon icon-stop"></i>
                </button>
                <!-- Delete Button -->
                <button
                  class="datalabs__delete card-body-button btn btn-reset"
                  @click.prevent="confirmLabDeletion(lab)"
                  title="Delete"
                >
                  <i class="icon icon-delete"></i>
                </button>
                <!-- Info button -->
                <button
                  class="datalabs__filter card-body-button btn btn-reset"
                  @click.prevent="openLabInfoModal(lab)"
                  title="Info"
                >
                  <i class="icon icon-info"></i>
                </button>
                <!-- Movie button -->
                <!-- <button class="datalabs__video card-body-button btn btn-reset" @click.prevent="" title="Video">
                  <i class="icon icon-movie-play font-18"></i>
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- --------------------------------- -->
    <!--          FEATURED LABS            -->
    <!-- --------------------------------- -->
    <h2 class="datalabs__featured-title"><i class="icon icon-featured text-primary bold-me"></i>Featured</h2>
    <div class="datalabs__featured section row">
      <!-- V-FOR ASSETS IN FEATURED ASSETS -->
      <div
        v-for="(asset, idx) in featuredAssets"
        :key="idx"
        class="col-cards col-sm-6 col-lg-3 col-xl-3 col-xxl-2 d-flex justify-content-center"
      >
        <!-- {{ asset.filename }} -->
        <div class="datalabs__item card theme-shadow">
          <div class="card-figure">
            <!-- <img
              class="card-img-top"
              :src="wpData.image_path + labLogo(asset.file_format.tags[0].name)"
              alt="Card image cap"
            /> -->
            <img class="card-img-top" :src="asset.file_format.picture" alt="Card image cap" />
          </div>
          <div class="card-body">
            <div class="card-body-content">
              <p class="card-title">
                <span class="name">{{ asset.file_format.datalab_type }}</span>
              </p>
              <!-- <p class="card-description">{{ lab.description }}</p> -->
              <!-- <p class="card-text">
                <em>{{ lab.image }}</em>
              </p>-->
              <!-- <p v-if="lab.status === 'Initializing'" class="card-text">{{ lab.status }}</p> -->
            </div>
            <div class="card-buttons">
              <button
                @click.prevent="auth && isUser ? createFromLabModal(asset) : openLoginOrRegisterModal()"
                title="Launch"
                class="datalabs__launch card-body-button btn btn-reset"
              >
                <i class="icon icon-play"></i>
              </button>
              <button
                @click.prevent="openAssetModal(asset)"
                class="datalabs__info card-body-button btn btn-reset"
                title="Info"
              >
                <i class="icon icon-info"></i>
              </button>
              <button
                v-if="checkIsUrlValid(asset)"
                @click.prevent="openVideo(asset)"
                class="datalabs__video card-body-button btn btn-reset"
                title="Video"
              >
                <i class="icon icon-movie-play font-18"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- --------------------------------- -->
    <!--            ALL LABS               -->
    <!-- --------------------------------- -->
    <h2 class="datalabs__all-title"><i class="icon icon-assignment text-primary bold-me"></i>All</h2>
    <div class="datalabs__all section row">
      <!-- V-FOR ASSETS IN PROCESSING ASSETS -->
      <div
        v-for="(asset, idx) in processingAssets"
        :key="idx"
        class="col-cards col-sm-6 col-lg-3 col-xl-3 col-xxl-2 d-flex justify-content-center"
      >
        <!-- {{ asset.filename }} -->
        <div class="datalabs__item card theme-shadow">
          <div class="card-figure">
            <!-- <img class="card-img-top" :src="wpData.image_path + labLogo(asset.file_format.tags[0].name)"
              alt="Card image cap" /> -->
            <img class="card-img-top" :src="asset.file_format.picture" alt="Card image cap" />
          </div>
          <div class="card-body">
            <div class="card-body-content">
              <p class="card-title">
                <span class="name">{{ asset.file_format.datalab_type }}</span>
              </p>
              <!-- <p class="card-description">{{ lab.description }}</p> -->
              <!-- <p class="card-text">
                <em>{{ lab.image }}</em>
              </p>-->
              <!-- <p v-if="lab.status === 'Initializing'" class="card-text">{{ lab.status }}</p> -->
            </div>
            <div class="card-buttons">
              <button
                @click.prevent="auth && isUser ? createFromLabModal(asset) : openLoginOrRegisterModal()"
                class="datalabs__launch card-body-button btn btn-reset"
                title="Launch"
              >
                <i class="icon icon-play"></i>
              </button>
              <button
                @click.prevent="openAssetModal(asset)"
                class="datalabs__info card-body-button btn btn-reset"
                title="Info"
              >
                <i class="icon icon-info"></i>
              </button>
              <button
                v-if="checkIsUrlValid(asset)"
                @click.prevent="openVideo(asset)"
                class="datalabs__video card-body-button btn btn-reset"
                title="Video"
              >
                <i class="icon icon-movie-play font-18"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- edit lab modal -->
    <edit-lab-modal
      class="datalabs__edit-lab-modal"
      v-if="showModal"
      :id="currentLab.id"
      :initName="currentLab.name"
      :initDesc="currentLab.description"
      @lab-saved="getLabs"
      @closeModal="showModal = false"
    />
    <message-modal
      v-if="showDeleteModal"
      class="message-modal"
      :title="modalTitle"
      :message="modalMessage"
      :cancel="true"
      :okButtonText="'Delete'"
      @confirmed="deleteLab"
      @closeMessageModal="showDeleteModal = false"
    />
    <!-- asset modal view -->
    <asset-modal
      class="asset__modal"
      v-if="currentFeaturedLab"
      :data="currentFeaturedLab"
      @openAssetLab="createFromLabModal"
    />

    <!-- running lab modal view -->
    <lab-info-modal
      class="lab-info__modal"
      v-if="currentLab"
      :data="currentLab"
      @openAssetLab="openLab"
      @editAssetLab="openEditLabModal"
      @deleteAssetLab="confirmLabDeletion"
      @closeModal="$('.lab-info__modal').modal('hide')"
    />

    <!-- asset lab modal to open template labs in new lab -->
    <asset-lab-modal
      class="asset__lab-modal"
      v-if="newFromLab"
      :assets="newFromLab.assets"
      :isProcessing="true"
      :lab="newFromLab.lab"
      :searchParams="[{ resource_type: 'Datalab' }]"
      :selectAll="false"
      :initName="newFromLab.name"
      :initDesc="newFromLab.description"
      @lab-ready="launchLab"
    />
    <!-- login or register modal-->
    <login-or-register-modal
      v-if="showLoginOrRegisterModal"
      class="login-or-register-modal"
      :title="modalTitle"
      :message="modalMessage"
      :cancel="true"
      :okButtonText="okButtonText"
      :cancelButtonText="cancelButtonText"
      :cancelCallbackFunction="cancelCallbackFunction"
      :okCallbackFunction="okCallbackFunction"
      @confirmed=""
      @closeMessageModal=""
    />
    <!-- video modal -->
    <video-modal :videoLink="videoLink" :selectedLabVideoTitle="selectedLabVideoTitle" />
  </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import * as api from '@/lib/api'
import helpers from '@/lib/helpers'
import moment from 'moment'
import EditLabModal from '@/components/EditLabModal.vue'
import MessageModal from '@/components/MessageModal.vue'
import AssetLabModal from '@/components/AssetLabModal.vue'
import LabInfoModal from '@/components/LabInfoModal.vue'
import AssetModal from '@/components/AssetModal.vue'
import VideoModal from '@/components/VideoModal.vue'

export default {
  name: 'datalabs',
  components: {
    EditLabModal,
    MessageModal,
    AssetLabModal,
    AssetModal,
    LabInfoModal,
    LoginOrRegisterModal: MessageModal,
    VideoModal,
  },
  data() {
    return {
      labs: [],
      // Currently edited query
      currentLab: null,
      showModal: false,
      warningMessage: '',
      //Confirm delete modal
      modalTitle: '',
      modalMessage: '',
      okButtonText: '',
      cancelButtonText: '',
      okCallbackFunction: function() {},
      cancelCallbackFunction: function() {},
      selectedLabForDelete: null,
      showDeleteModal: false,
      showLoginOrRegisterModal: false,
      processingAssets: [],
      featuredAssets: [],
      newFromLab: null,
      currentFeaturedLab: null,
      registerUrl: process.env.VUE_APP_ENTRY_URL.includes('preportal2')
        ? process.env.VUE_APP_ENTRY_URL.replace('/preportal2', '') + '/register'
        : process.env.VUE_APP_ENTRY_URL.replace('/portal', '') + '/register',
      videoLink: '',
      selectedLabVideoTitle: '',
      // wpData,
    }
  },
  props: {
    wpData: {
      type: Object,
    },
  },
  computed: {
    labsNeedRefresh() {
      return this.$store.getters.labsNeedRefresh
    },
    auth() {
      return this.$store.getters.isAuthenticated
    },
    isUser() {
      return this.$store.getters.isUser
    },
  },
  methods: {
    openEditLabModal(lab) {
      // First set the currently edited lab data
      this.currentLab = lab
      this.showModal = true
      // Open modal on next DOM update
      Vue.nextTick(() => {
        $('.datalabs__edit-lab-modal').modal('show')
      })
    },
    confirmLabDeletion(lab) {
      this.selectedLabForDelete = lab
      this.modalTitle = 'Confirm Delete'
      this.modalMessage = `Delete Datalab "${lab.name}"?`
      this.showDeleteModal = true
      Vue.nextTick(() => {
        $('.message-modal').modal('show')
      })
    },
    async deleteLab() {
      await api.deleteLab(this.selectedLabForDelete.id)
      // reload labs
      this.selectedLabForDelete = null
      this.getLabs()
    },
    async getLabs() {
      // sort by most recently created lab first
      const response = await api.getSavedLabs({
        // sort_by: 'last_access_time',
        // order_by: 'desc',
        // TODO: pagination
        size: 1000,
      })
      // if (response) this.$emit('finishLoading')
      console.log('LABSRESPONSE', { response })
      // List of {name, description, lab-list}
      if (response.results) {
        self.warningMessage = ''
        this.labs = response.results.map(function(row) {
          //   return {
          //     ...row
          //   };
          // });
          // this.labs = this.labs.map(function (row) {
          //   // filter-list.search is currently a string object
          //   // For now just hack it to make the data JSON parseable
          //   // TODO: backend should just return an object
          let query = {}
          let search = row['filter-list'].search
          if (search && search !== 'None') {
            if (typeof search == 'object') {
              query = helpers.objectFromArrayOfObjectsHandleDuplicates(search)
            } else if (typeof search == 'string') {
              query = helpers.objectFromArrayOfObjectsHandleDuplicates(JSON.parse(search.replace(/'/gi, '"')))
            }
            query.mode = query.coord ? 'map' : 'query'
          }
          //   // Add router link params
          return {
            ...row,
            filterLink: {
              name: 'assets',
              query,
            },
            lastAccess: moment.utc(row['last_access_time']).fromNow(),
          }
        })

        this.labs.sort((a, b) =>
          a.last_access_time > b.last_access_time ? -1 : b.last_access_time > a.last_access_time ? 1 : 0
        )
        console.log('THIS LABS', this.labs)
      } else if (typeof response === 'string') {
        this.labs = []
        this.warningMessage = response
      }
    },
    async stopLab(lab) {
      await api.stopLab(lab.id)
      // reload labs
      this.getLabs()
    },
    async startLab(lab) {
      await api.startLab(lab.id)
      // reload labs
      this.getLabs()
    },
    async openLab(lab) {
      if (lab.status === 'Running') {
        this.$router.push({
          name: 'lab',
          params: { id: lab.id, labUrl: lab.url },
        })
      } else if (lab.status === 'Paused') {
        const response = await api.startLab(lab.id)
        lab.status = 'Initializing'
        // // reload labs
        // this.getLabs()
        //Function definition for polling status api
        async function poll(response) {
          let data = await api.pollAssetLabStatus(response.id)
          console.log('status is', data.status, 'so waiting 1s')
          let waitedTime = 0
          while (data.status != 'Running' && waitedTime < 60000) {
            await wait(2000)
            waitedTime += 2000
            data = await api.pollAssetLabStatus(response.id)
            console.log({ data }, waitedTime)
          }
          console.log({ data })
          return data
        }
        //wait function that returns a promise
        function wait(ms = 1000) {
          return new Promise((resolve) => {
            // console.log(`waiting ${ms} ms...`)
            setTimeout(resolve, ms)
          })
        }
        const data = await poll(response)
        console.log({ data })
        if (data.status === 'Running') {
          this.$router.push({
            name: 'lab',
            params: { id: lab.id, labUrl: lab.url },
          })
        } else {
          console.log('waited > 30 seconds status is still: ', data.status)
        }
      }
      // if (lab.status === 'Running') {
      //   window.open(lab.url, lab.id)
      // }
    },
    async getProcessingAssets() {
      const response = await api.getAssetsNoAggregations({
        resource_type: 'Datalab',
        size: '200',
      })
      this.processingAssets = response.results
      console.log('Datalabs processing assets', this.processingAssets)
      this.featuredAssets = response.results.filter((asset) => {
        const tags = asset.file_format.tags.map((tag) => tag.name)
        return tags.includes('Featured')
      })
      // console.log('FEATURED', this.featuredAssets)
      if (response) this.$emit('finishLoading')
    },
    async refreshLabs() {
      await this.getLabs()
    },
    //Needed no more - DELETE, delete also referenced images? think so
    // labLogo(image) {
    //   switch (image) {
    //     case 'GSSC Lab':
    //       return 'jupyter-logo.svg'
    //     case 'gLAB':
    //       return 'gAGE.png'
    //     case 'Octave':
    //       return 'octave.svg'
    //     case 'UbiSAP RINEX Viewer':
    //       return 'nsa3.png'
    //     case 'UbiSAP RINEX PPK Processor':
    //       return 'nsa2.png'
    //     case 'UbiSAP Binary to RINEX':
    //       return 'nsa1.png'
    //     case 'UbiSAP FLAMINGO Processor':
    //       return 'nsa5.png'
    //     case 'GSSC Datalab Demonstrator 1':
    //       return 'gssc_demo_1.png'
    //     case 'GNSS Analysis app':
    //       return 'gnss_analysis.png'
    //     default:
    //       return 'jupyter-logo.svg'
    //   }
    // },
    createFromLabModal(asset) {
      // console.log(asset)
      this.newFromLab = {
        assets: [asset],
        name: asset.file_format.datalab_type, //`${asset.resource_type.resource_type_labs[0].name}`,
        description: asset.file_format.description, //`Datalab created from ${asset.filename} featured lab`,
        lab: asset.file_format.datalab_type,
      }
      // Open modal on next DOM update
      Vue.nextTick(() => {
        $('.asset__lab-modal').modal()
      })
    },
    launchLab(id, url) {
      console.log('SHOULD LAUNCH LAB NOW')
      this.$router.push({ name: 'lab', params: { id: id, labUrl: url } })
    },
    openAssetModal(data) {
      // First set the current asset data
      this.currentFeaturedLab = data
      // Open modal on next DOM update
      Vue.nextTick(() => {
        $('.asset__modal').modal()
      })
    },
    openLabInfoModal(lab) {
      console.log(lab)
      this.currentLab = lab
      Vue.nextTick(() => {
        $('.lab-info__modal').modal()
      })
    },
    openLoginOrRegisterModal() {
      this.modalTitle = 'Sign in or sign up for an account'
      this.modalMessage = 'The resource you are trying to access is for registered users only.'
      this.okButtonText = 'Sign In'
      this.cancelButtonText = 'Sign Up'
      this.showLoginOrRegisterModal = true
      this.cancelCallbackFunction = this.openRegister
      this.okCallbackFunction = this.openLogin
      Vue.nextTick(() => {
        $('.login-or-register-modal').modal('show')
      })

      // window.open(this.registerUrl)
    },
    openRegister() {
      window.open(this.registerUrl)
    },
    openLogin() {
      $('.login-or-register-modal').modal('hide')
      this.$emit('login')
    },
    clsMostRecent(idx) {
      if (idx === 0) return 'most-recent'
    },
    openVideo(asset) {
      console.log('open', { asset })
      this.selectedLabVideoTitle = asset.file_format.datalab_type
      this.videoLink = asset.file_format.regular_expression
      $('.video-modal').on('hidden.bs.modal', () => {
        this.videoLink = ''
      })
      Vue.nextTick(() => {
        $('.video-modal').modal('show')
      })
      // axios
      //   .get(downloadVideoLink, {
      //     headers: {
      //       Accept: 'video/mp4;charset=UTF-8',
      //     },
      //   })
      //   .then((response) => {
      //     const URL = window.URL || window.webkitURL
      //     this.videoLink = URL.createObjectURL(new Blob([response.data], { type: 'video/mp4' }))
      //     Vue.nextTick(() => {
      //       $('.video-modal').modal('show')
      //     })
      //   })
      //   .catch((error) => {
      //     console.log('error', error)
      //   })
      // if (asset.file_format) {
      //   console.log('open')
      //   if (asset.file_format.regular_expression) {
      //     console.log('open', asset.file_format.regular_expression)
      //     if (helpers.isUrlValid(asset.file_format.regular_expression)) {
      //       console.log('open Video', asset.file_format.regular_expression)
      //     }
      //   }
      // }
    },
    checkIsUrlValid(asset) {
      return helpers.isUrlValid(asset.file_format.regular_expression)
    },
  },
  async mounted() {
    if (this.auth && this.isUser) {
      await this.getLabs()
      console.log('LABS', this.labs)
    }
    await this.getProcessingAssets()
    if (this.$route.params.datalabTo) {
      if (this.auth && this.isUser) {
        const assetToSelect = this.processingAssets.find(
          (asset) => asset.file_format.datalab_type === this.$route.params.datalabTo
        )
        this.createFromLabModal(assetToSelect)
      } else {
        this.openLoginOrRegisterModal()
      }
    }
  },
  watch: {
    labsNeedRefresh: async function() {
      if (this.labsNeedRefresh) {
        console.log(this.labsNeedRefresh)
        this.$store.dispatch('labsNeedRefresh', {
          value: false,
        })
        await this.getLabs()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/globals';
// @import "~@/styles/cards";

.datalabs {
  min-height: 60vh;
  padding: 9px;

  h2 {
    display: table;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 70%;
      top: 100%;
      width: 70px;
      height: 4px;
      border-radius: 2px;
      background: $main;
    }

    i {
      padding-left: 0;
    }
  }

  .section {
    margin-bottom: 40px;
  }

  .alert-primary {
    margin-top: 20px;
  }

  .card-last-access {
    margin-bottom: 6px;
    font-size: 12px;
  }

  .most-recent {
    border: 2px solid $deep-space-1;
  }

  i.icon-progress::before {
    display: inline-block;
    animation: spin 3s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
